import React, { useState, useEffect, useCallback, useRef } from 'react';
import Toast from '@xpeng/rc-toast';
import { StationDto } from '../../api/stations';
import { getPlatform, throttle, flatten, debounce, isInApp, reportUserBehavior, getChannel } from '../../utils/common';
import InputSearch from '@assets/comments/input-search.png';
import StationTypeCard from "./components/station-type-card"
import Tag from "./components/tag"
import { getH5ComponentConfig, queryMapLabeling, queryMapCityLabeling, queryMapAggregateLabeling, findNearByStationV2, findCityStation } from "../../api/map-stations"
import { judgeHeight, judgeMapHeight, judgeListPaddingTop, judgeListHeight, location2CityCode, judgeListWrapHeight } from "./config"
import type { StationPoint, StationComponent, NearByStationVO } from "../../api/map-stations"
import {
  go2LoginIfNot, getLoginInfoPromise
} from '../../utils/common';
import './app.less';
import { use } from 'echarts';
import unionAxios from '../../utils/union-axios';
import { trackGdp } from '../../utils/gio-report';

declare const AMap: any;

interface Location {
  lng: number | string;
  lat: number | string;
}
interface StationShow extends StationDto {
  // 暂无用处
  price?: number;
}
const defalutPoint = {
  lng: 113.38477,
  lat: 23.15944,
  citycode: '020',
  cityName: '广州市'
}
/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1
 * @param  {[string]} screenHeight 组件高度
 * @param  {[string]} searchBarDisplay 搜索框是否显示（false|true） false为不显示 true为显示
 */
const getUrlValue = queryName => {
  let reg = new RegExp('(^|&)' + queryName + '=([^&]*)(&|$)', 'i');
  const query = window.location.search; // '?s=1&f=7'
  let r = query.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
};

// 获取高德定位promise
const getLocationGeoPro = _map => {
  return new Promise((resolve, reject) => {
    _map.plugin('AMap.Geolocation', () => {
      const geolocation = new AMap.Geolocation({
        enableHighAccuracy: true, // 是否使用高精度定位，默认:true
        timeout: 10000, // 超过10秒后停止定位，默认：无穷大
        buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        buttonPosition: 'RB'
      });
      geolocation.getCurrentPosition((status, result) => {
        console.log(result);
        if (status === 'complete') {
          const address = result && result.addressComponent;
          const cityName = (address && address.city) || (address && address.province);
          resolve({
            lng: result.position.lng,
            lat: result.position.lat,
            citycode: address.citycode,
            cityName
          });
        } else {
          reject('高德定位失败');
          console.error('高德定位失败:' + result.message);
        }
      });
    });
  });
};

const MyLocationPoint = `<div class="my-location"></div>`;
const LocationPoint = `<div class="location"></div>`;


// 地图marker收集
const MarkerCollector = new Map<string, any>();
const CountryMarkerCollector = new Map<string, any>();
const StationCache = new Map<string, StationShow>();

// 中心坐标
const locationMarker = new Map<string, any>();

const App = () => {
  const [initConfig, setInitConfig] = useState<any>(null)
  const [cityConfig, setCityConfig] = useState<{ cityCode: string, cityName: string }>({
    cityCode: defalutPoint.citycode,
    cityName: defalutPoint.cityName
  })
  const [loadingStation, setLodaingStation] = useState<boolean>(false)
  const [uid, setUid] = useState<string>('');
  const [keyWord, setKeyWord] = useState<string>('')
  const infoCardRef = useRef<any>(null);
  const MyLocaleRef = useRef<Location | null>(null);
  const [centerLocale, setCenterLocale] = useState<Location | null>();
  // 判断搜索框是否需要显示
  const searchBarShow = getUrlValue('haveSearchBox') === '1';
  const code = getUrlValue('code');

  // 保存地图站点markers
  const ClusterRef = useRef<any>(null);
  const CountryClusterRef = useRef<any>(null);
  const CurrentStationIdRef = useRef<string>('');
  // 当前物理位置信息

  const [$map, set$map] = useState<any>(null);
  const [freshLoading, setFreshLoading] = useState<boolean>(false);
  const [currentStation, setCurrentStation] = useState<StationShow | null>(
    null
  );
  const mapHeight = getUrlValue('height');

  const [stationTypeList, setStationTypeList] = useState<StationComponent[]>([]);
  // 请求城市全部
  const queryCitysServiceInstance = React.useRef<ReturnType<typeof queryMapCityLabeling>>(queryMapCityLabeling());
  // 请求附近20km站点
  const queryLabelingServiceInstance = React.useRef<ReturnType<typeof queryMapLabeling>>(queryMapLabeling());
  // 保存需要取消的请求实例
  const cancelList = useRef<any[]>([])

  // 保存需要取消的请求实例
  const queryMapAggregateLabelingServiceInstance = React.useRef<ReturnType<typeof queryMapAggregateLabeling>>(queryMapAggregateLabeling());


  const [expandFlag, setExpandFlag] = useState<boolean>(false)
  const [stationList, setStationList] = useState<NearByStationVO[]>([])

  const [listLoading, setListLoading] = useState<boolean>(false)


  const wholeCityNums = useRef<any[]>(null) as any
  const nearbyStations = useRef<any[]>(null) as any
  const map2 = useRef<any>(null)
  const [selectStationType, setSelectStationType] = useState<StationComponent | undefined>();
  const selectStationTypeRef = useRef<StationComponent>(null) as any
  const getStationInfo = (stationId, stationCache) => {
    if (StationCache.has(stationId)) {
      setCurrentStation(StationCache.get(stationId) as StationShow);
      return;
    }
    // 获取具体的免费站信息
    setCurrentStation(stationCache);
  };



  // 站点类型筛选
  useEffect(() => {
    changeStationType(selectStationType)
  }, [selectStationType])

  const changeStationType = async (type) => {
    console.log('更改选中站点类型')
    selectStationTypeRef.current = type
    if (centerLocale?.lat && centerLocale?.lng) {
      setLodaingStation(true)
      if (!type?.code) {
        setExpandFlag(false)
        let zoom = map2.current.getZoom()
        if (zoom < 9) {
          debounceGetWholeCountryNums.current(map2.current)
        } else {
          let citycode = (await location2CityCode({ map: map2.current, lat: centerLocale?.lat, lng: centerLocale?.lng })).cityCode
          queryLabelingThrottler.current({ map: map2.current, ...centerLocale, citycode })
        }
      } else {
        await getNearByStationV2({
          lon: centerLocale?.lng,
          lat: centerLocale?.lat,
          radius: initConfig?.radius,
          filterCriteriaCodeList: selectStationTypeRef.current?.filterCodeList
        })
        let zoom = map2.current.getZoom()
        if (zoom < 9) {
          debounceGetWholeCountryNums.current(map2.current, selectStationTypeRef.current?.filterCodeList)
        } else {
          let citycode = (await location2CityCode({ map: map2.current, lat: centerLocale?.lat, lng: centerLocale?.lng })).cityCode
          queryLabelingThrottler.current({ map: map2.current, ...centerLocale, filterCriteriaCodeList: selectStationTypeRef.current?.filterCodeList, citycode })
        }
      }
      setLodaingStation(false)
    }
  }


  // 根据选取的类型获取附近站点数据
  const getNearByStationV2 = async ({ lon, lat, radius, filterCriteriaCodeList }) => {
    // 配置类行为指定城市or当前城市时取城市接口,否则取附近接口
    if (MyLocaleRef.current?.lng && MyLocaleRef.current?.lat) {
      let nearRes = await findNearByStationV2({
        source: 1,
        radius: radius,
        sortType: 2,
        filterCriteriaCodeList: filterCriteriaCodeList,
        latitude: lat,
        longitude: lon,
        pageSize: 50,
        cityCode: [1, 2].includes(initConfig?.type) ? cityConfig?.cityCode : '',
        currentLon: MyLocaleRef.current?.lng || '',
        currentLat: MyLocaleRef.current?.lat || ''
      })
      setStationList(nearRes.data.result)
      console.log('res.data.result', nearRes.data.result);
    }
  }


  const getConfig = async (code: string) => {
    setListLoading(true)
    console.log('curPoint', MyLocaleRef.current);
    // 用户当前所在城市
    const curCity = (MyLocaleRef?.current?.lat && MyLocaleRef?.current?.lng)
      ? (await location2CityCode({ map: map2.current, lat: MyLocaleRef?.current?.lat, lng: MyLocaleRef?.current?.lng }))
      : { cityCode: defalutPoint.citycode, cityName: defalutPoint.cityName }
    getH5ComponentConfig({ code }).then(res => {
      const { code, msg, data } = res;
      if (![200, 0].includes(code)) {
        Toast.show(msg);
      } else {
        console.log('getConfig data', data);

        setInitConfig(data)
        if (data.type === 0) {
          // 附近距离
        } else if (data.type === 1) {
          // 指定城市
        } else if (data.type === 2) {
          // 所在城市
          // 所在城市的citycode后端不返回，需要前端自己获取
          setCityConfig({
            cityCode: curCity?.cityCode,
            cityName: curCity?.cityName
          })
        }
        // 已经初始化的typelist不会再变化
        !stationTypeList.length && setStationTypeList(data.searchList)
      }
    }).then(err => {
      console.error(err);
    }).finally(() => {
      setListLoading(false)
    })
  }


  // 获取url的code
  useEffect(() => {
    console.log(code, 'code')
    if (code && initConfig?.code !== code) {
      getConfig(code)
    }
  }, [code, MyLocaleRef.current?.lng, MyLocaleRef.current?.lat])

  // 初始化地图基类
  useEffect(() => {
    init()
  }, []);

  const init = async () => {
    // 上报埋点
    trackGdp('P11247', 'B001', {
      user_channel: `${getChannel()}`,
      config_code: code
    })
    console.log('初始化地图基类');
    const map = new AMap.Map('amap-wrap', {
      zoom: 5,
      zooms: [3, 20],
      animateEnable: true,
      expandZoomRange: true // zooms设置20无效，是否支持可以扩展最大缩放级别,和zooms属性配合使用，设置为true的时候，zooms的最大级别在PC上可以扩大到20级，移动端还是高清19/非高清20
    });
    set$map(map);
    map2.current = map
    map.on('moveend', mapMoveFunc);
    map.on('zoomend', mapZoomFunc);
  }

  const mapZoomFunc = async () => {
    const curZoom = map2.current?.getZoom();
    console.log('onZoomEnd', curZoom)
    if (curZoom < 9) {
      if (!wholeCityNums.current?.length) {
        debounceGetWholeCountryNums.current(map2.current, selectStationTypeRef.current?.filterCodeList)
      } else {
        drawWholeCountryPoly(wholeCityNums.current, map2.current)
      }
    }
  }
  const mapMoveFunc = async () => {
    console.log(map2.current.getZoom(), 'mapMoveFunc current zoom')
    if (!map2.current) return
    let position = map2.current.getCenter();
    console.log(position, 'position')
    setCenterLocale({ lat: position.lat, lng: position.lng })
    getStationList(map2.current, { lat: position.lat, lng: position.lng })
  }

  const getStationList = async (map, location) => {
    await queryCitysServiceInstance.current.cancel(cancelList.current);
    let shouldrefrehCityLabeling = false
    let zoom = map.getZoom();
    // 按指定城市or当前城市查找时需要根据黑色坐标位置更新城市编码
    const newCity = (await location2CityCode({ map: map2.current, lat: location.lat, lng: location.lng }))
    console.log(location, MyLocaleRef.current, newCity.cityCode, cityConfig?.cityCode, 'location')
    if (location.lat === MyLocaleRef.current?.lat && location.lng === MyLocaleRef.current?.lng) {
      console.log('回定位点')
      setCityConfig({
        cityCode: newCity.cityCode,
        cityName: newCity.cityName
      })
    }
    if (newCity.cityCode !== cityConfig?.cityCode) {
      console.log('城市变化', newCity.cityName, newCity.cityCode)
      setCityConfig({
        cityCode: newCity.cityCode,
        cityName: newCity.cityName
      })
      shouldrefrehCityLabeling = true
    }
    //判断大于11时，显示子项
    if (zoom >= 9) {
      //   if (!wholeCityNums.current?.length) {
      //     debounceGetWholeCountryNums.current(map, selectStationTypeRef.current?.filterCodeList)
      //   } else {
      //     drawWholeCountryPoly(wholeCityNums.current, map)
      //   }

      // } else {
      console.log(newCity, location, '按指定城市or当前城市查找时需要根据黑色坐标位置更新城市编码')
      if ([1, 2].includes(initConfig?.type)) {
        shouldrefrehCityLabeling && queryLabelingThrottler.current({ map, lat: location.lat, lng: location.lng, citycode: newCity.cityCode, filterCriteriaCodeList: selectStationTypeRef.current?.filterCodeList })
      } else {
        queryLabelingThrottler.current({ map, lat: location.lat, lng: location.lng, citycode: newCity.cityCode, filterCriteriaCodeList: selectStationTypeRef.current?.filterCodeList })
      }
    }

  }


  const markerClick = async (_map, station) => {
    _map.off('moveend', mapMoveFunc);
    // cancel所有请求 避免出现气泡后重新渲染导致气泡消失
    await queryCitysServiceInstance.current.cancel(cancelList.current);
    await queryLabelingServiceInstance.current.cancel(cancelList.current);
    // 停止移动监听
    setTimeout(() => {
      _map.on('moveend', mapMoveFunc);
    }, 5000)

    let CurrentStationId = CurrentStationIdRef.current;
    _map.setCenter([station.longitude, station.latitude]);
    // 判断第二次点击的站点是否为同一个
    if (CurrentStationId === station.stationId) {
      const currentMarker = MarkerCollector.get(CurrentStationId);

      const extData = currentMarker.getExtData();
      if (extData.isActive) {
        currentMarker.setTop(false)
        currentMarker.setContent(extData.normal);
      } else {
        // 聚焦：放大
        currentMarker.setContent(extData.active);
        currentMarker.setTop(true)
      }
      return;
    }
    // 查询当前
    const currentMarker = MarkerCollector.get(CurrentStationId);
    const nextMarker = MarkerCollector.get(station.stationId);
    // 取消聚焦
    if (CurrentStationId) {
      currentMarker.setTop(false)
      currentMarker.setContent(currentMarker.getExtData().normal);
    }
    const extDataOfNewMarker = nextMarker.getExtData();
    // 聚焦：放大
    nextMarker.setContent(extDataOfNewMarker.active);
    nextMarker.setTop(true)

    getStationInfo((CurrentStationIdRef.current = station.stationId), station);
  };

  const computedPosition = (text) => {
    let div1Height = 0;
    let div1 = document.createElement('div')
    div1.innerHTML = text
    div1.style.setProperty('width', '200px')
    div1.style.setProperty('font-size', '24px')
    div1.style.setProperty('line-height', '26px')
    div1.style.setProperty('font-weight', 'bold')
    div1.style.setProperty('overflow', 'hidden')
    div1.style.setProperty('position', 'absolute')
    div1.style.setProperty('text-overflow', 'ellipsis')
    div1.style.setProperty('display', '-webkit-box')
    div1.style.setProperty('-webkit-line-clamp', '2')
    div1.style.setProperty('-webkit-box-orient', 'vertical')
    div1.style.setProperty('opacity', '0')
    document.body.appendChild(div1)
    div1Height = div1.offsetHeight
    document.body.removeChild(div1)
    return div1Height > 26

  }

  const cleanMap = (_map: any, markers) => {
    if (markers?.length) {
      _map.remove(markers);
    }
    if (ClusterRef.current) {
      ClusterRef.current.clearMarkers();
    }
    if (CountryClusterRef.current) {
      CountryClusterRef.current.clearMarkers();
    }
    _map.clearMap();

    // 清理完地图后，要把定位重新画上去
    const myLocation = MyLocaleRef.current;
    if (myLocation) {
      const marker = new AMap.Marker({
        content: MyLocationPoint,
        position: [myLocation.lng, myLocation.lat]
      });
      _map.add(marker);
    }
  };

  const filterStationName = (stationName: string) => {
    if (stationName && stationName.length > 22) {
      return `${stationName.slice(0, 22)}...`
    } else {
      return stationName
    }
  }

  const getUid = async () => {
    const UA = navigator.userAgent || "";
    const isDragon = /XdragonWebView/i.test(UA); // 骁龙app
    const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
    const isWX = /micromessenger/i.test(UA); // 微信
    const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
    const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序
    let newuid = ''
    if (isXPApp) {
      // console.log('app获取uid', (await getLoginInfoPromise())?.uid);
      // newuid = uid ? uid : (await getLoginInfoPromise())?.uid || ''
    } else if (isMyApp || isWXApp) {
      console.log('小程序获取uid', getUrlValue('uid'), window.location);
      newuid = getUrlValue('uid') || ''
    } else if (isDragon) {
      // @ts-ignore
      window.xdragon.callHandler('getUser', res => {
        newuid = res?.uid || ''
      })
    } else {
      // console.log('浏览器获取uid', Cookie.get());
      // newuid = Cookie.get('wasxuid_r') || ''
    }
    setUid(newuid)
    return newuid
  }

  const queryLabelingThrottler = React.useRef(
    throttle(async ({ map, lat, lng, citycode, filterCriteriaCodeList }) => {
      try {
        console.log('开始获取扎标数据', citycode)
        setFreshLoading(true)
        let res1 = await queryLabelingServiceInstance.current.axiosFun({
          source: 1,
          latitude: lat,
          longitude: lng,
          filterCriteriaCodeList,
          currentLon: MyLocaleRef.current?.lng,
          currentLat: MyLocaleRef.current?.lat,
          uid: await getUid()
        }, [])
        let res2 = await queryCitysServiceInstance.current.axiosFun({
          source: 1,
          cityCode: citycode,
          filterCriteriaCodeList,
          currentLon: MyLocaleRef.current?.lng,
          currentLat: MyLocaleRef.current?.lat,
          uid: await getUid()
        }, [])
        let data1 = res1.data?.result || []
        let data2 = res2.data?.result || []
        let stationList = dupRemove([...data1, ...data2], 'stationId')
        nearbyStations.current = stationList

        setFreshLoading(false);
        drawStation(stationList, map);
        // @ts-ignore
      } catch (error: any) {
        setFreshLoading(false);
        console.log('queryLabelingThrottler error', error);
        if (error?.message === 'cancel') {
          return
        }
      }
    }, 500)
  );

  const debounceGetWholeCountryNums = React.useRef(
    throttle(async (map, filterCriteriaCodeList?) => {
      try {
        await queryMapAggregateLabelingServiceInstance.current.axiosFun({ source: 1, filterCriteriaCodeList }, cancelList.current).then(res => {
          wholeCityNums.current = res?.data?.cityStationLabelingList
          if (map.getZoom() < 11) {
            drawWholeCountryPoly([...res?.data?.cityStationLabelingList], map)
          }
          setFreshLoading(false);
        })
        // @ts-ignore
      } catch (error: any) {
        setFreshLoading(false);
        if (error?.message === 'cancel') {
          return
        }
      }
    }, 500)
  );

  const dupRemove = (list: any[], key: string) => {
    let map = new Map()
    return list.filter(i => {
      return !map.has(i[key].toString()) && map.set(i[key].toString(), '')
    })
  }

  const returnMyLocation = () => {
    // 上报埋点
    trackGdp('P11247', 'B007', {
      user_channel: getChannel(),
      config_code: initConfig?.code || ''
    })
    // map2.current?.off('moveend', mapMoveFunc);
    // setTimeout(() => {
    //   map2.current?.on('moveend', mapMoveFunc);
    // }, 3000)
    const myLocation = MyLocaleRef.current;
    if (myLocation) {
      $map.setCenter([myLocation.lng, myLocation.lat]);
    }
  };

  const freshStationList = useCallback(() => {
    // 上报埋点
    trackGdp('P11247', 'B008', {
      user_channel: getChannel(),
      config_code: initConfig?.code || ''
    })
    console.log(cityConfig?.cityCode || defalutPoint.citycode, 'nitConfig.current?.cityCode||defalutPoint.citycode')
    // 防止无地图调用以及重复点击
    if (!$map || freshLoading) return;
    // 刷新后清空站点缓存
    if (MyLocaleRef.current && centerLocale) {
      StationCache.clear();
      queryLabelingThrottler.current(
        {
          map: $map,
          lng: centerLocale?.lng,
          lat: centerLocale?.lat,
          filterCriteriaCodeList: selectStationTypeRef.current?.filterCodeList,
          citycode: cityConfig?.cityCode || defalutPoint.citycode
        }
      );
    }
  }, [$map, freshLoading]);

  // 统一处理
  const position2Query = (
    { map, lng, lat, citycode }:
      { map: any, lng?: string | number, lat?: number | string, citycode?: string }
  ) => {
    if (lng && lat) {
      map.setCenter([lng, lat]);
      // 设置一下缩放
      map.setZoom(13);
      const marker2 = new AMap.Marker({
        content: LocationPoint,
        position: [lng, lat]
      });
      map.add(marker2);
      locationMarker.set('centerLocation', marker2)

      setCenterLocale({ lng, lat });
    }
    queryLabelingThrottler.current({ map, lng, lat, citycode, filterCriteriaCodeList: selectStationTypeRef.current?.filterCodeList });
  };

  const drawWholeCountryPoly = (polys, _map: any) => {
    if (polys) {
      cleanMap(_map, Array.from(CountryMarkerCollector.values()));
      CountryMarkerCollector.clear();

      const handlePolys = polys.map(item => {
        return Array.from({ length: item.stationNum }, () => ({ ...item, lat: item.latitude, lng: item.longitude }))
      })
      let markerList = flatten(handlePolys)

      const markers = markerList.map((station, index) => {
        const markerNormalTmp = `<div class="marker zIndex1"></div>`;
        const marker = new AMap.Marker({
          content: markerNormalTmp,
          extData: {
            normal: markerNormalTmp,
            active: null,
            originData: { ...station },
            isActive: true,
          },
          position: [station.longitude, station.latitude],
          offset: new AMap.Pixel(0, 40)
        });
        CountryMarkerCollector.set(station.code + '' + index, marker);

        marker.on('click', e => {
          e.target.setTop(true);
          // 上报埋点
          trackGdp('P11247', 'B009', {
            user_channel: getChannel(),
            config_code: initConfig?.code || '',
            station_id: station?.stationId || '',
          })
          const extData = e.target.getExtData();
          e.target.setExtData({ ...extData, isActive: !extData.isActive })
          e.target.setzIndex(1005);
          markerClick(_map, station);
        });
        return marker;
      });
      CountryClusterRef.current = new AMap.MarkerClusterer(_map, markers, {
        // 所有点的中心点
        averageCenter: true,
        gridSize: 110,
        zoomOnClick: false,
        // 自定义聚合显示
        renderClusterMarker: context => {
          let hasXp = false;
          context.markers.forEach(marker => {
            const station = marker.getExtData().originData;
            if (station.selfOperateStationNum > 0) {
              hasXp = true;
            }
          });
          let overThousand = context.count >= 1000
          context.marker.setContent(
            `<div class="map-marker-clusterer ${hasXp ? 'wrap-self' : 'wrap-partner'}">
              <span class="${overThousand ? 'small-size' : ''}">
                ${overThousand ? '999+' : context.count}
              </span>
            </div>`
          );
          context.marker.on('click', ev => {
            let zoom = _map.getZoom();
            //跳转到该区域位置
            _map.setZoomAndCenter(9, ev.target.getPosition());
          });
        }
      });
    }

  }

  const drawStation = (_stationList: StationPoint[], _map: any) => {
    if (_stationList) {
      CurrentStationIdRef.current = '';
      setCurrentStation(null);
      cleanMap(_map, Array.from(MarkerCollector.values()));
      MarkerCollector.clear();
      const markers = _stationList.map(station => {
        let cls;
        let clsArr: string[] = [];
        if (station.operationMode === 1) {
          if (station.s4Num > 0) {
            clsArr = ['xpSuperFast'];
          } else if (station.dcNum > 0) {
            clsArr = ['xpQuick'];
          } else {
            clsArr = ['xpSlow'];
          }
        } else if (station.operationMode === 3) {
          if (station.showPreferredPartnership) {
            clsArr = ['preferred_third'];
          } else {
            clsArr = ['third'];
          }
        } else {
          if (station.showPreferredPartnership) {
            clsArr = ['preferred_third'];
          } else {
            clsArr = ['third'];
          }
        }
        // 免费站
        if (station.showFreeV2) {
          clsArr.push('free');
        }
        // 专享站
        if (station.showXpOwner) {
          clsArr.push('vip');
        }
        cls = clsArr.join(' ');

        const markerNormalTmp = `<div class="marker zIndex1 ${cls}"></div>`;
        const markerActiveTmp = `<div class="marker zIndex2 active ${cls}">
          <SwitchTransition>
            <CSSTransition
              key={${station.stationId}}
              class="fade"
            >
              <div class="card card-distence-short ${computedPosition(station.stationName) ? '' : 'card-short'}" id="station-card">
                <div class="card-title">
                  <div id="station-name" class="station-name">${filterStationName(station.stationName)}</div>
                  <div id="station-name-hidden" class="station-name-hidden">${filterStationName(station.stationName)}</div>
                </div>
                <div class="address">距离您${station.distance}公里</div>
              </div>
            </CSSTransition>
          </SwitchTransition>
        </div>`;
        const marker = new AMap.Marker({
          content: markerNormalTmp,
          extData: {
            normal: markerNormalTmp,
            active: markerActiveTmp,
            originData: { ...station },
            isActive: true,
          },
          position: [station.longitude, station.latitude],
        });
        MarkerCollector.set(station.stationId, marker);

        marker.on('click', e => {
          // 上报埋点
          trackGdp('P11247', 'B009', {
            user_channel: getChannel(),
            config_code: initConfig?.code || '',
            station_id: station?.stationId || '',
          })
          console.log('click', station);
          e.target.setTop(true);
          const extData = e.target.getExtData();
          e.target.setExtData({ ...extData, isActive: !extData.isActive })
          e.target.setzIndex(105);
          markerClick(_map, station);
        });
        return marker;
      });
      ClusterRef.current = new AMap.MarkerClusterer(_map, markers, {
        // 所有点的中心点
        averageCenter: true,
        gridSize: 110,
        // 自定义聚合显示
        renderClusterMarker: context => {
          let hasXp = false;
          context.markers.forEach(marker => {
            const station = marker.getExtData().originData;
            if (station.operationMode === 1) {
              hasXp = true;
            }
          });
          let overThousand = context.count >= 1000
          context.marker.setContent(
            `<div class="map-marker-clusterer ${hasXp ? 'wrap-self' : 'wrap-partner'}">
              <span class="${overThousand ? 'small-size' : ''}">
                ${overThousand ? '999+' : context.count}
              </span>
            </div>`
          );
        }
      });
    }
  };

  useEffect(() => {
    console.log('initConfig.', initConfig);

    if (!$map || !initConfig) return;

    // 当前定位逻辑 || 所在城市
    if (initConfig?.type === 0 || initConfig?.type === 2) {
      const optPro = new Promise<any>(resolve => {
        getLocationGeoPro($map)
          .then((res: any) => {
            resolve({ ...res });
          })
          .catch(() => {
            Toast.show('获取当前定位失败，请稍后重试', {
              containerStyle: { zIndex: 9999 }
            });
            resolve(defalutPoint);
          });
      });
      optPro
        .then(({ lng, lat, citycode, cityName }) => {
          console.log(lng, lat, citycode, cityName, '获取到的当前定位')
          position2Query({ map: $map, lng, lat, citycode });
          setCityConfig({
            cityName,
            cityCode: citycode
          })
          const marker = new AMap.Marker({
            content: MyLocationPoint,
            position: [lng, lat]
          });
          $map.add(marker);
          MyLocaleRef.current = { lng, lat };
          return;
        })
        .catch(err => {
          console.error(err);
        });
    }
    // 指定城市
    else {
      $map.plugin('AMap.Geocoder', () => {
        const geolocation1 = new AMap.Geocoder({
          city: cityConfig?.cityCode//默认：“全国”
        });
        console.log(cityConfig, '获取定位前的参数')
        geolocation1.getLocation(cityConfig?.cityName, async (status, result) => {
          console.log(status, result, '获取定位的结果')
          if (status === 'complete' && result.geocodes?.length) {
            var lnglat = result.geocodes[0].location;
            // 刷新后清空站点缓存
            console.log("指定城市 resule", result);
            StationCache.clear();
            position2Query(
              {
                map: $map,
                lng: lnglat.lng,
                lat: lnglat.lat,
                citycode: cityConfig?.cityCode
              });
            const marker = new AMap.Marker({
              content: MyLocationPoint,
              position: [lnglat.lng, lnglat.lat]
            });
            $map.add(marker);
            MyLocaleRef.current = { lng: lnglat.lng, lat: lnglat.lat };
          } else {
            Toast.show('获取定位失败');
          }
        });
      });
    }

  }, [$map, initConfig]);

  const searchAddr = value => {
    expandFlag && setExpandFlag(false)
    // 防止无地图调用以及重复点击
    if (!$map || freshLoading) return;
    $map.plugin('AMap.Geocoder', () => {
      const geolocation1 = new AMap.Geocoder({
        city: '' //默认：“全国”
      });
      geolocation1.getLocation(value, async (status, result) => {
        if (status === 'complete' && result.geocodes?.length) {
          console.log('高德api搜索地址结果', result.geocodes)
          var lnglat = result.geocodes?.[0]?.location;
          setCityConfig({
            cityName: result.geocodes?.[0]?.addressComponent?.city,
            cityCode: result.geocodes?.[0]?.addressComponent?.citycode
          })
          // 刷新后清空站点缓存
          if (centerLocale) {
            StationCache.clear();
            position2Query(
              {
                map: $map,
                lng: lnglat?.lng,
                lat: lnglat?.lat,
                citycode: result.geocodes?.[0]?.addressComponent?.citycode,
              });
          }
        } else {
          Toast.show('请输入具体地址，例：省+市+具体地点');
        }
      });
    });
  };

  const toFold = () => {
    // 上报埋点
    trackGdp('P11247', 'B006', {
      user_channel: getChannel(),
      config_code: initConfig?.code || '',
    })
    setExpandFlag(false)
  }
  const toExpand = () => {
    // 上报埋点
    trackGdp('P11247', 'B005', {
      user_channel: getChannel(),
      config_code: initConfig?.code,
    })
    setExpandFlag(true)
    changeStationType(selectStationType)
  }
  return (
    <div className="react-map-wrap" style={{ height: judgeHeight(mapHeight) }}>
      <div className='infoCard' ref={infoCardRef}>
        {searchBarShow ? (
          <div className="input-container" onClick={() => {
            // 上报埋点
            trackGdp('P11247', 'B002', {
              user_channel: `${getChannel()}`,
              config_code: initConfig?.code
            })
          }}>
            <img className="input-search" alt="" src={InputSearch} onClick={() => { searchAddr(keyWord) }} />
            <input
              className="input-box"
              type="text"
              placeholder="搜索地点"
              onChange={e => {
                console.log(e.target.value, 'keyword')
                if (e && e.target) {
                  searchAddr(e.target.value);
                }
                setKeyWord(e.target.value)
              }}
            />
          </div>
        ) : null}
        <StationTypeCard
          toExpand={toExpand}
          expandFlag={expandFlag}
          setSelectStationType={setSelectStationType}
          selectStationType={selectStationType}
          stationTypeList={stationTypeList}
          initConfig={initConfig}
          cityConfig={cityConfig}
          location={centerLocale}
          configCode={initConfig?.code}
        />
      </div>
      {expandFlag ? (
        loadingStation ?
          <div className='openList'
            style={{
              paddingTop: `calc(${infoCardRef.current?.clientHeight}px + 1.2rem)`,
              height: `calc(100% - ${infoCardRef.current?.clientHeight}px - 1.2rem)`,
            }}
          >
            <div className='listEmpty'>
              正在载入...
            </div>
          </div>
          :
          <div className='openList'
            style={{
              paddingTop: `calc(${infoCardRef.current?.clientHeight}px + 1.2rem)`,
              height: `calc(100% - ${infoCardRef.current?.clientHeight}px - 1.2rem)`,
            }}
          >
            <div className="mask">
              <div className="close" onClick={toFold}>
                <div className='text'>收起</div>
                <div className='closeIcon'></div>
              </div>
            </div>
            <div className='listwrap'>
              <div className="line"></div>
              <div className='list'>
                {stationList?.map((i, index) => (
                  <div className="stationItem" key={index}>
                    <div className="stationName">{i.stationName}</div>
                    <div className="labels">
                      {i.stationLabelList.slice(0, 5).map(label =>
                        <Tag item={label} key={label.labelCode} />
                      )}
                    </div>
                    <div className="addr">
                      <span className='distance'>{i.distance}公里</span> |
                      <span className="addrDetail"> {i.stationAddr}</span>
                    </div>
                  </div>
                ))}
                <div className='no-more'>{stationList?.length >= 50 ? '最多显示50个站，更多站点请访问小鹏汽车APP' : '没有更多充电站了'}</div>
              </div>
            </div>
          </div>
      ) : null}
      <div style={{ paddingTop: '17vh', height: '100%' }}>
        <div id="amap-wrap" style={{ height: `calc(100% - 17vh)` }}>
          <div className="center-location"></div>
          <div className={'fresh-box'}>
            <div
              className={freshLoading ? 'fresh-btn btn-span' : 'fresh-btn'}
              onClick={freshStationList}
            ></div>
          </div>
          <div className={'location-box'}>
            <div className="location-btn" onClick={returnMyLocation}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
